
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.227 20.587l.701.692.703-.692 9.078-8.944a.414.414 0 01.582.59L14.203 22.18a.39.39 0 01-.548 0l-3.987-3.932a.417.417 0 010-.595l-.699-.715.7.715a.417.417 0 01.584.001l2.974 2.932zm3.677 11.22c8.231 0 14.904-6.672 14.904-14.903C31.808 8.673 25.135 2 16.904 2S2 8.673 2 16.904s6.673 14.904 14.904 14.904z","fill":"#33C173","stroke":"#fff","stroke-width":"2"}}),_c('path',{attrs:{"d":"M13.227 20.587l.701.692.703-.692 9.078-8.944a.414.414 0 01.582.59L14.203 22.18a.39.39 0 01-.548 0l-3.987-3.932a.417.417 0 010-.595l-.699-.715.7.715a.417.417 0 01.584.001l2.974 2.932zm3.677 11.22c8.231 0 14.904-6.672 14.904-14.903C31.808 8.673 25.135 2 16.904 2S2 8.673 2 16.904s6.673 14.904 14.904 14.904z","fill":"#33C173","stroke":"#fff","stroke-width":"2"}})])
          )
        }
      }
    